import MessageCreatorActionTypes from '../../conversations/types/message_creator';
import Q from 'q';

const MessageCreatorActions = { types: MessageCreatorActionTypes };

MessageCreatorActions.disable = function() {
  return {
    type: MessageCreatorActions.types.DISABLE
  };
};

MessageCreatorActions.enable = function() {
  return {
    type: MessageCreatorActions.types.ENABLE
  };
};

MessageCreatorActions.error = function(errors) {
  return {
    type: MessageCreatorActions.types.ERROR,
    errors: errors
  };
};

MessageCreatorActions.persist = function(message, url, conversation) {
  return Q($.ajax({
    url: url,
    type: 'POST',
    data: { conversation_message: { body: message.body, parent_id: message.parentId } },
    dataType: 'json'
  }));
};

function handleErrorResponse(jqXHR, textStatus, errorThrown) {
  var text = errorThrown || jqXHR.responseText;
  return isObjectEmpty(jqXHR.responseJSON) ? { errors: [text] } : jqXHR.responseJSON;
}

function isObjectEmpty(obj) {
  for(var o in obj) { if (obj.hasOwnProperty(o)) return false; }
  return true;
}

export default MessageCreatorActions;
